"use client";

import { Ban, Check, Minus, Pause, X } from "lucide-react";
import { memo } from "react";
import type { PipelineNodeStatus } from "../../types";

const DOT_CLASSES: Record<PipelineNodeStatus, string> = {
  planned: "h-2 w-2 rounded-full bg-gray-200",
  pending: "h-2 w-2 rounded-full bg-gray-300",
  active: "h-2 w-2 rounded-full bg-blue-500 animate-pulse",
  completed: "",
  failed: "",
  aborted: "",
  blocked: "",
  skipped: "",
};

export const StatusBadge = memo(function StatusBadge({
  status,
}: {
  status: PipelineNodeStatus;
}) {
  if (status === "completed")
    return <Check size={10} className="text-green-600 shrink-0" />;
  if (status === "failed")
    return <X size={10} className="text-red-600 shrink-0" />;
  if (status === "aborted")
    return <Ban size={10} className="text-orange-600 shrink-0" />;
  if (status === "blocked")
    return <Pause size={10} className="text-slate-500 shrink-0" />;
  if (status === "skipped")
    return <Minus size={10} className="text-gray-400 shrink-0" />;
  return <span className={`shrink-0 inline-block ${DOT_CLASSES[status]}`} />;
});
